/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowcoverskip3Inputs */

const en_aiflowcoverskip3 = /** @type {(inputs: Aiflowcoverskip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue without a cover`)
};

const de_aiflowcoverskip3 = /** @type {(inputs: Aiflowcoverskip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Cover weiter`)
};

/**
* | output |
* | --- |
* | "Continue without a cover" |
*
* @param {Aiflowcoverskip3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowcoverskip3 = /** @type {((inputs?: Aiflowcoverskip3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowcoverskip3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowcoverskip3(inputs)
	return de_aiflowcoverskip3(inputs)
});
export { aiflowcoverskip3 as "aiFlowCoverSkip" }